module.exports = __webpack_public_path__ + "static/media/braip.982b3193.svg";